import { useCallback, useContext, useState } from 'react';
import { ParentContext } from '../ParentContext';
import { updateGlobal } from 'projectSpecific/sports/dbActions/globals';

export const useLocationMapping = () => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { database_fns } = fns
  const { paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}

  const [updating, setUpdating] = useState()

  const cb_update = () => {
    setUpdating()
  }

  const updateFieldDataToDb = useCallback(({ imageMap_state, callback }) => {
    const { currentLocation,
      selectedGlobalData,
      selectedLocationData,
      selectedLocationProp,
      currentFloormap,
      currentZone,
    } = imageMap_state
    setUpdating(true)
    if (selectedGlobalData && selectedLocationData && selectedLocationProp) {
      const _locationKey = _.findKey(selectedGlobalData, { name: currentLocation.name })
      if (selectedGlobalData[_locationKey]) {
        selectedGlobalData[_locationKey].zone = {
          imageKey: currentFloormap,
          zoneIndex: currentZone.text
        }
        updateGlobal(database_fns, pathViews, selectedLocationProp, selectedGlobalData, cb_update)
      }
    }
  }, []);

  const updateZonesToDb = useCallback(({ imageMap_state, callback }) => {
    setUpdating(true)
    const { currentElements, collectionName, currentFloormap } = imageMap_state
    const svge = [...currentElements]
    database_fns.update_dataCollection(pathViews, collectionName, currentFloormap, { zones: svge }, cb_update)
  }, []);

  return {
    updateFieldDataToDb,
    updateZonesToDb,
    updating,
  }
}
